function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4286 14.9999C20.4286 15.4546 20.2479 15.8906 19.9265 16.2121C19.605 16.5336 19.1689 16.7142 18.7143 16.7142H3.2857C2.83104 16.7142 2.395 16.5336 2.07351 16.2121C1.75202 15.8906 1.57141 15.4546 1.57141 14.9999V5.57136C1.57141 5.1167 1.75202 4.68067 2.07351 4.35918C2.395 4.03768 2.83104 3.85707 3.2857 3.85707H6.71427L8.42855 1.28564H13.5714L15.2857 3.85707H18.7143C19.1689 3.85707 19.605 4.03768 19.9265 4.35918C20.2479 4.68067 20.4286 5.1167 20.4286 5.57136V14.9999Z",
  stroke: "#FEFFFE",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11 13.2856C12.8935 13.2856 14.4286 11.7506 14.4286 9.85707C14.4286 7.96353 12.8935 6.4285 11 6.4285C9.10643 6.4285 7.57141 7.96353 7.57141 9.85707C7.57141 11.7506 9.10643 13.2856 11 13.2856Z",
  stroke: "#FEFFFE",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.de6e2e31.svg";
export { ForwardRef as ReactComponent };